import { render, staticRenderFns } from "./index-job-state-badge.component.vue?vue&type=template&id=494aea24&scoped=true"
import script from "./index-job-state-badge.component.vue?vue&type=script&lang=ts"
export * from "./index-job-state-badge.component.vue?vue&type=script&lang=ts"
import style0 from "./index-job-state-badge.component.vue?vue&type=style&index=0&id=494aea24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494aea24",
  null
  
)

export default component.exports